module.exports = __webpack_public_path__ + "images/00b59452972e46753299db0a7e51a33f.png";